import React, { useState, useEffect } from "react";
import axios from "axios";
import VoteComponent from "./VoteComponent.js";
import FeedbackComponent from "./FeedbackComponent.js";

const StatusView = ({ baseURL, res_URL }) => {
  const [currentSession,setCurrentSession] = useState({
    data_fetched: false,
    fetched_session: {},
    fetched_data: [],
    feedbacksActive: 'deactive'
  });

  useEffect(() => {
    axios.get(`${baseURL}/session`)
    .then(res => {
      if(typeof(res.data)!=="string") {
        setCurrentSession({
          ...currentSession,
          data_fetched: true,
          fetched_session: res.data,
          feedbacksActive: res.data['feedbacks']
        });
      }
    })
    .catch(err => console.log(`[Session${err.name}]: ${err.code} [Status]: ${err.request.status}`));
  }, [baseURL,currentSession]);

  return (
    <React.Fragment>
      <VoteComponent
        parse_session={currentSession.fetched_session}
        hostURL={baseURL}
      />
      <FeedbackComponent
        s_sts={currentSession.feedbacksActive}
        resources_url={res_URL}
      />
    </React.Fragment>
  );
}

export default StatusView;